// Events fired by BOTH apps. Platform-specific events live in
// mobile-action-events.ts / web-action-events.ts.
export enum ActionEvents {
  OnboardingLogin = 'app_onboarding_log_in',
  TaskComplete = 'task_complete',
  TaskDelete = 'task_delete',
  TaskRestore = 'task_restore',
  TaskCreate = 'task_create',
  TagCreate = 'tag_create',
  TagDelete = 'tag_delete',
  GoalComplete = 'goal_complete',
  GoalDelete = 'goal_delete',
  GoalCreate = 'goal_create',
  GoalEdit = 'goal_edit',
  GoalProgressUpdated = 'goal_progress_updated',
  SubGoalCreate = 'subgoal_create',
  SubGoalEdit = 'subgoal_edit',
  SearchResultClicked = 'search_result_clicked',
  LifeAreaCreate = 'life_area_create',
  LifeAreaArchive = 'life_area_archive',
  LifeAreaDelete = 'life_area_delete',
  CancelSubscription = 'cancel_subscription_clicked',
  ShareFeedback = 'share_feedback',
  VisionCreate = 'vision_create',
  VisionEdit = 'vision_edit',
  PushNotificationUpdated = 'push_notifications_updated',
  InitialPushNotificationsQuestion = 'push_notifications_disabled_open_settings',
  PmfSurveyHowWouldYouFeel = 'pmf_survey_how_would_you_feel',
  PmfSurveyMainBenefit = 'pmf_survey_main_benefit',
  PmfSurveyIdealPerson = 'pmf_survey_ideal_person',
  PmfSurveyImprovement = 'pmf_survey_improvement',
  PmfSurveyMissing = 'pmf_survey_what_was_missing',
  PmfSurveyChurnReason = 'pmf_survey_churn_reason',
}
